/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tumor-board-occurrence.reducer';

export const TumorBoardOccurrenceDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tumorBoardOccurrenceEntity = useAppSelector(state => state.tumorBoardOccurrence.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tumorBoardOccurrenceDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.detail.title">TumorBoardOccurrence</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.id">Id</Translate>
            </span>
          </dt>
          <dd>{tumorBoardOccurrenceEntity.id}</dd>
          <dt>
            <span id="eventName">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.eventName">Event Name</Translate>
            </span>
            <UncontrolledTooltip target="eventName">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.eventName" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOccurrenceEntity.eventName}</dd>
          <dt>
            <span id="eventDescription">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.eventDescription">Event Description</Translate>
            </span>
            <UncontrolledTooltip target="eventDescription">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.eventDescription" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOccurrenceEntity.eventDescription}</dd>
          <dt>
            <span id="scheduleStartTime">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.scheduleStartTime">Schedule Start Time</Translate>
            </span>
            <UncontrolledTooltip target="scheduleStartTime">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.scheduleStartTime" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOccurrenceEntity.scheduleStartTime}</dd>
          <dt>
            <span id="scheduleEndTime">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.scheduleEndTime">Schedule End Time</Translate>
            </span>
            <UncontrolledTooltip target="scheduleEndTime">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.scheduleEndTime" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOccurrenceEntity.scheduleEndTime}</dd>
          <dt>
            <span id="scheduleDate">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.scheduleDate">Schedule Date</Translate>
            </span>
            <UncontrolledTooltip target="scheduleDate">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.scheduleDate" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOccurrenceEntity.scheduleDate}</dd>
          <dt>
            <span id="outcomeSummary">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.outcomeSummary">Outcome Summary</Translate>
            </span>
            <UncontrolledTooltip target="outcomeSummary">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.outcomeSummary" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOccurrenceEntity.outcomeSummary}</dd>
          <dt>
            <span id="startedAt">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.startedAt">Started At</Translate>
            </span>
            <UncontrolledTooltip target="startedAt">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.startedAt" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOccurrenceEntity.startedAt}</dd>
          <dt>
            <span id="completedAt">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.completedAt">Completed At</Translate>
            </span>
            <UncontrolledTooltip target="completedAt">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.completedAt" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOccurrenceEntity.completedAt}</dd>
          <dt>
            <span id="createdById">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.createdById">Created By Id</Translate>
            </span>
            <UncontrolledTooltip target="createdById">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.createdById" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOccurrenceEntity.createdById}</dd>
          <dt>
            <span id="createdByType">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.createdByType">Created By Type</Translate>
            </span>
          </dt>
          <dd>{tumorBoardOccurrenceEntity.createdByType}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOccurrenceEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOccurrenceEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOccurrenceEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOccurrenceEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOccurrenceEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.board">Board</Translate>
          </dt>
          <dd>{tumorBoardOccurrenceEntity.board ? tumorBoardOccurrenceEntity.board.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tumor-board-occurrence" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tumor-board-occurrence/${tumorBoardOccurrenceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TumorBoardOccurrenceDetail;
